export interface BillingPaymentsHistory {
  amount: number;
  year: number;
}

export interface BillingPaymentsSchedule {
  annualDueDate: string | null;
  q1DueDate: string | null;
  q2DueDate: string | null;
  q3DueDate: string | null;
  q4DueDate: string | null;
}

export interface BillingPaymentsPayment {
  paymentDate: string | null;
  period: BillingPaymentPeriod;
  amount: number;
  dueDate: string | null;
  status: BillingPaymentStatus;
}

export interface BillingPayments {
  paymentSchedule: BillingPaymentsSchedule | null;
  payments: BillingPaymentsPayment[];
  history: BillingPaymentsHistory[];
  unpaidAmount: number;
}

export enum BillingPaymentPeriod {
  Q1 = "q1",
  Q2 = "q2",
  Q3 = "q3",
  Q4 = "q4",
  Annual = "annual",
}
export enum BillingPaymentStatus {
  Paid = "paid",
  Unpaid = "unpaid",
  Overdue = "overdue",
  Upcoming = "upcoming",
}
